import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./overlays/ErrorBoundary";
import "./index.css";

// Kiosk hardening: auto-reload every 12 hours to prevent Chrome memory
// bloat from running the WebGL scene continuously for days.
const RELOAD_AFTER_MS = 12 * 60 * 60 * 1000;
window.setTimeout(() => {
  console.log("[lifecycle] 12h auto-reload");
  window.location.reload();
}, RELOAD_AFTER_MS);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
